import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { SAVE_AUTOMATION } from "../store/automation-actions";
import { CLEAR_CURRENT_AUTOMATION, SET_EDITING } from "../store/automation-mutations";
import { ACTION_BY_KEY } from "../store/automation-getters";
import { mapFields } from "@joandvgv/vuex-map-fields";
import Dropdown from "./dropdown";
import TriggerArguments from "./trigger-arguments";
import ActionArguments from "./action-arguments";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import EmailEditorTemplates from "../../../util-components/on-demand-email-templates/email-editor-templates";
import { LOAD_PLAN_LIMIT } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { filter, intersectionWith, isEmpty, isEqual, isNull, isString, keys, some, values, map, isArray } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {
    AutomationDropdown: Dropdown,
    TriggerArguments,
    ActionArguments,
    SimpleButton,
    EmailEditorTemplates
  },
  data() {
    return {
      nonce: 1
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AutomationStore", {
    loading: "loading",
    editing: "editing",
    savingStatus: "savingStatus",
    saving: "saving",
    triggers: state => values(state.automationData.entities.trigger),
    allActions: state => state.automationData.result.actions
  })), mapFields("AutomationStore", ["currentAutomation.trigger", "currentAutomation.triggerArguments", "currentAutomation.action", "currentAutomation.actionArguments", "currentAutomation.shared", "shareSelection"])), mapGetters("AutomationStore", [ACTION_BY_KEY])), mapState("AccountPlanStore", ["currentPagePlan"])), {}, {
    actions() {
      let validActions = [];
      this.trigger.actions.forEach(group => {
        validActions = [...validActions, ...this.allActions[group]];
      });
      validActions = _mapInstanceProperty(validActions).call(validActions, actionKey => this.ACTION_BY_KEY(actionKey));
      return validActions;
    },
    shouldShowActionSelect() {
      const hasTrigger = !isEmpty(this.trigger);
      return hasTrigger && this.allArgumentsFilled(this.triggerArguments, this.trigger["trigger-arguments"]);
    },
    shouldShowSave() {
      const hasAction = !isEmpty(this.action);
      const hasActionArguments = !isEmpty(this.actionArguments);
      return this.shouldShowActionSelect && hasAction && hasActionArguments && this.allArgumentsFilled(this.actionArguments, this.action["action-arguments"]);
    },
    sectionTitle() {
      if (this.editing) {
        return this.$t("automations.boardLevel.editingAutomation");
      } else {
        return this.$t("automations.boardLevel.createNewAutomation");
      }
    },
    sharedText() {
      return this.shared ? this.$t("automations.boardLevel.triggerableByAnyCollaborator") : this.$t("automations.boardLevel.triggerableOnlyByMe");
    },
    triggersByShareType() {
      const onlyTriggersBoardRelated = filter(this.triggers, trigger => {
        var _context;
        return !isEmpty(trigger["trigger-arguments"]) && _findInstanceProperty(_context = trigger["trigger-arguments"]).call(_context, triggerArg => triggerArg.id === "board");
      });
      return this.shared ? onlyTriggersBoardRelated : this.triggers;
    },
    shouldShowTemplateControls() {
      const hasAction = !isEmpty(this.action);
      return hasAction && this.action.key === "email";
    },
    currentEmailIfActive() {
      if (!this.shouldShowTemplateControls) return "";
      const hasActionArguments = !isEmpty(this.actionArguments);
      return hasActionArguments && this.actionArguments.email.body;
    },
    emailSubject() {
      var _this$actionArguments, _this$actionArguments2;
      return (_this$actionArguments = (_this$actionArguments2 = this.actionArguments.email) == null ? void 0 : _this$actionArguments2.subject) != null ? _this$actionArguments : "";
    }
  }),
  watch: {
    action() {
      this.$nextTick(() => {
        if (!this.editing) {
          this.actionArguments = {};
        } else {
          //Persist only those that are called the same
          const currentKeys = keys(this.actionArguments);
          const newKeys = map(this.action["action-arguments"], "id");
          const commonKeys = intersectionWith(currentKeys, newKeys, isEqual);
          const newArgs = {};
          for (const key of commonKeys) {
            newArgs[key] = this.actionArguments[key];
          }
          this.actionArguments = newArgs;
        }
      });
    },
    trigger() {
      this.$nextTick(() => {
        if (!this.editing) {
          this.triggerArguments = {};
          this.actionArguments = {};
          this.action = {};
        }
      });
    }
  },
  mounted() {
    this.backToSelect();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapMutations("AutomationStore", [CLEAR_CURRENT_AUTOMATION, SET_EDITING])), mapActions("AutomationStore", [SAVE_AUTOMATION])), mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT])), {}, {
    allArgumentsFilled(rawArgs, rawParent) {
      var _rawParent$filter, _context2;
      //Some arguments needs to be ignored
      // "Pinned" and "sendEmailOnBehalf" are ignored because not filling them count as false
      // "Title" is ignored because the value is not required
      const nameIgnoreList = ["pinned", "title", "sendEmailOnBehalf"];
      const typeIgnoreList = ["boolean", "title"];
      let parent = (_rawParent$filter = rawParent == null ? void 0 : _filterInstanceProperty(rawParent).call(rawParent, ({
        type
      }) => !_includesInstanceProperty(typeIgnoreList).call(typeIgnoreList, type))) != null ? _rawParent$filter : [];
      const args = _reduceInstanceProperty(_context2 = keys(rawArgs)).call(_context2, (acc, curr) => {
        const isFollowupAndAssignee = this.action.key === "follow-up" && curr === "assignees";
        if (!_includesInstanceProperty(nameIgnoreList).call(nameIgnoreList, curr) && !isFollowupAndAssignee) {
          acc[curr] = rawArgs[curr];
        }
        return acc;
      }, {});

      //If no arguments, all are filled
      if (isNull(parent)) {
        return true;
      } else {
        var _args$offset;
        //verify if assignees dropdown is showing up to make it optional
        parent = this.action.key === "follow-up" ? filter(parent, item => item.id !== "assignees") : parent;

        // verify if custom days is filled
        const isOffsetFilled = this.action.key !== "follow-up" || !isArray(args.offset) || !((_args$offset = args.offset) != null && _args$offset.some(curr => isEmpty(curr.value)));

        //Arguments are valid if none of the set keys are empty
        const isEverySetKeyFilled = !some(values(args), value => isString(value) ? value === "" : isEmpty(value)) && isOffsetFilled;

        //Theres no mismatch between set arguments and number of expected arguments
        const isNumberOfArgumentsSame = values(args).length == values(parent).length;
        return isEverySetKeyFilled && isNumberOfArgumentsSame;
      }
    },
    async handleSave() {
      if (this.actionArguments.email) {
        var _this$$refs$actionArg, _this$$refs$actionArg2, _this$$refs$actionArg3;
        const body = (_this$$refs$actionArg = this.$refs.actionArgComponent) == null ? void 0 : (_this$$refs$actionArg2 = _this$$refs$actionArg.$refs.component[0]) == null ? void 0 : (_this$$refs$actionArg3 = _this$$refs$actionArg2.$refs.emailEditor) == null ? void 0 : _this$$refs$actionArg3.getHTML();
        if (this.actionArguments.email.body !== body) {
          this.$refs.actionArgComponent.handleInput(_objectSpread(_objectSpread({}, this.actionArguments.email), {}, {
            body: body
          }), "email");
        }
      }
      await this.SAVE_AUTOMATION();
      this.LOAD_PLAN_LIMIT(this.currentPagePlan);
      this.backToSelect();
    },
    stopEditing() {
      this.backToSelect();
      this.CLEAR_CURRENT_AUTOMATION();
      this.SET_EDITING(false);
    },
    getKey(obj) {
      return obj ? obj.key : Math.random();
    },
    clearTemplate() {
      //eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("emailArgument::clearHtml");
      this.$refs.actionArgComponent.handleInput(_objectSpread(_objectSpread({}, this.actionArguments.email), {}, {
        subject: ""
      }), "email");
    },
    handleTemplateSelect({
      html,
      subject
    }) {
      //eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("emailArgument::setHtml", html);
      if (!isEmpty(subject)) this.$refs.actionArgComponent.handleInput(_objectSpread(_objectSpread({}, this.actionArguments.email), {}, {
        subject: subject
      }), "email");
    },
    backToSelect() {
      this.shareSelection = false;
      this.CLEAR_CURRENT_AUTOMATION();
    },
    isEmpty(value) {
      return isEmpty(value);
    }
  })
});